import { Component, OnInit } from "@angular/core";

@Component({
  selector: "app-send-received-reviews",
  templateUrl: "./send-received-reviews.component.html",
  styleUrls: ["./send-received-reviews.component.scss"],
})
export class SendReceivedReviewsComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
